var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.buttonClass,
      attrs: { id: "phone-button", type: "button" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [
      _c(_vm.buttonSvgComponent, {
        tag: "component",
        attrs: { size: _vm.isDetailView ? "18" : "24" },
      }),
      _vm._v(" "),
      _vm.showText
        ? _c("span", {
            class: !_vm.isDetailView ? "ml-1" : null,
            domProps: { textContent: _vm._s(_vm.buttonText) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }